<template>
  <div class="pdf-wrapper w-100">
    <div style="position: absolute; z-index: 10; top: 7px; right: 50px">
      <!-- Search input (can be enabled if needed) -->
    </div>

    <div
      style="height: calc(100vh - 360px); overflow-y: auto; overflow-x: hidden"
      ref="pdfContainer"
    >
      <div ref="pdfViewer" class="pdf-container"></div>
    </div>

    <div
      class="
        viewResume-paginaTion-modal
        align-items-center
        justify-content-center
        d-flex
        w-100
      "
    >
      <div class="pagination">
        <b-pagination
          align="center"
          first-number
          last-number
          v-model="currentPage"
          :total-rows="totalPages"
          :per-page="1"
          @input="goToPage"
        >
          <template #prev-text>
            <span
              ><img src="../../assets/img/accessconnew/pageleft.svg" alt
            /></span>
          </template>
          <template #next-text>
            <span
              ><img src="../../assets/img/accessconnew/pageright.svg" alt
            /></span>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/web/pdf_viewer.css";

export default {
  name: "pdfview",
  props: {
    pdfUrl: String,
    searchText: String,
  },
  data() {
    return {
      pdfDoc: null,
      currentPage: 1,
      totalPages: 0,
      scale: 1,
    };
  },
  watch: {
    searchText() {
      this.highlightText();
    },
  },
  mounted() {
    this.loadPdf();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    goToPage(page) {
      this.currentPage = page;
      this.renderPage(page);
    },
    async loadPdf() {
      pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
      try {
        this.pdfDoc = await pdfjsLib.getDocument(this.pdfUrl).promise;
        this.totalPages = this.pdfDoc.numPages;
        this.zoomOut();
        // this.renderPage(this.currentPage);
      } catch (error) {
        console.error("Error loading PDF:", error);
      }
    },
    async renderPage(pageNum) {
      const pdfViewer = this.$refs.pdfViewer;

      // Clear existing content
      pdfViewer.innerHTML = "";

      const page = await this.pdfDoc.getPage(pageNum);
      const viewport = page.getViewport({ scale: this.scale });

      // Create a container for canvas and text layer
      const pageContainer = document.createElement("div");
      pageContainer.className = "page-container";
      pageContainer.style.position = "relative";
      // pageContainer.style.height = `${viewport.height}px`;
      // pageContainer.style.width = `${viewport.width}px`;
      pageContainer.style.width = `100%`;
      pageContainer.style.height = `100%`;
      pdfViewer.appendChild(pageContainer);

      const devicePixelRatio = window.devicePixelRatio * 1.5;
      const scaledViewport = page.getViewport({
        scale: this.scale * devicePixelRatio,
      });

      // Render the canvas for the page
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = scaledViewport.width;
      canvas.height = scaledViewport.height;
      pageContainer.appendChild(canvas);

      canvas.style.width = `${viewport.width}px`;
      canvas.style.height = `${viewport.height}px`;
      pageContainer.appendChild(canvas);

      const renderContext = {
        canvasContext: context,
        viewport: scaledViewport,
      };
      await page.render(renderContext).promise;

      // Scale back to match the visual size
      context.scale(devicePixelRatio, devicePixelRatio);

      // Render the text layer
      const textContent = await page.getTextContent();
      const textLayerDiv = document.createElement("div");
      textLayerDiv.className = "textLayer";
      textLayerDiv.style.position = "absolute";
      textLayerDiv.style.top = "0";
      textLayerDiv.style.left = "0";
      textLayerDiv.style.width = `${viewport.width}px`; // Match canvas width
      textLayerDiv.style.height = `${viewport.height}px`; // Match canvas height
      // textLayerDiv.style.transform = `scale(${1 / devicePixelRatio})`;

      textLayerDiv.style.transformOrigin = "0 0";
      textLayerDiv.style.pointerEvents = "none";

      pageContainer.appendChild(textLayerDiv);

      pdfjsLib.renderTextLayer({
        textContent,
        container: textLayerDiv,
        viewport,
        textDivs: [],
      });

      this.$nextTick(() => {
        this.highlightText();
      });
    },
    // highlightText() {
    //   const pdfViewer = this.$refs.pdfViewer;
    //   const textLayerDiv = pdfViewer.querySelector(".textLayer");

    //   if (!textLayerDiv) return;

    //   const spans = Array.from(textLayerDiv.children);
    //   if (spans.length === 0) return;

    //   // Step 1: Reset existing highlights
    //   spans.forEach((span) => {
    //     if (span.dataset.originalText) {
    //       span.innerHTML = span.dataset.originalText;
    //     } else {
    //       span.dataset.originalText = span.innerHTML;
    //     }
    //   });

    //   // Step 2: Exit if search text is empty
    //   if (!this.searchText.trim()) return;

    //   const searchRegex = new RegExp(this.searchText, "gi");

    //   // Step 3: Combine all text from spans
    //   const fullText = spans
    //     .map((span) => span.dataset.originalText || span.textContent)
    //     .join("");

    //   // Step 4: Find matches
    //   let match;
    //   while ((match = searchRegex.exec(fullText)) !== null) {
    //     const start = match.index;
    //     const end = start + match[0].length;

    //     // Step 5: Apply highlights to corresponding spans
    //     let charIndex = 0;
    //     for (let i = 0; i < spans.length; i++) {
    //       const span = spans[i];
    //       const text = span.dataset.originalText || span.textContent;
    //       const spanStart = charIndex;
    //       const spanEnd = charIndex + text.length;

    //       if (spanEnd > start && spanStart < end) {
    //         // Part of the span overlaps with the matched text
    //         const highlightStart = Math.max(0, start - spanStart);
    //         const highlightEnd = Math.min(text.length, end - spanStart);

    //         span.innerHTML =
    //           text.slice(0, highlightStart) +
    //           `<span class="highlighted-text">${text.slice(
    //             highlightStart,
    //             highlightEnd
    //           )}</span>` +
    //           text.slice(highlightEnd);
    //       }

    //       charIndex += text.length;
    //     }
    //   }
    // },

    highlightText() {
      const pdfViewer = this.$refs.pdfViewer;
      const textLayerDiv = pdfViewer.querySelector(".textLayer");

      if (!textLayerDiv) return;

      const spans = Array.from(textLayerDiv.children);
      if (spans.length === 0) return;

      // Step 1: Reset existing highlights
      spans.forEach((span) => {
        if (span.dataset.originalText) {
          span.innerHTML = span.dataset.originalText;
        } else {
          span.dataset.originalText = span.innerHTML;
        }
      });

      // Step 2: Exit if search text is empty
      if (!this.searchText.trim()) return;

      const searchRegex = new RegExp(this.searchText, "gi");

      // Step 3: Construct fullText while keeping spaces where they exist in the PDF
      let fullText = "";
      let charMap = [];

      spans.forEach((span, index) => {
        const text = span.dataset.originalText || span.textContent;

        // Preserve spaces between spans if they are actually spaces in the document
        if (index > 0) {
          const prevSpan = spans[index - 1];
          const prevRect = prevSpan.getBoundingClientRect();
          const currRect = span.getBoundingClientRect();

          // If the current span has moved significantly right, insert a space
          if (currRect.left > prevRect.right + 2) {
            fullText += " ";
            charMap.push({ index: fullText.length - 1, span: null }); // Map the space
          }
        }

        charMap.push({ index: fullText.length, span });
        fullText += text;
      });

      // Step 4: Find matches in fullText
      let match;
      while ((match = searchRegex.exec(fullText)) !== null) {
        const start = match.index;
        const end = start + match[0].length;

        // Step 5: Apply highlights correctly across spans
        let highlighted = "";
        for (let i = 0; i < charMap.length; i++) {
          if (!charMap[i].span) continue; // Skip mapped spaces

          const { index, span } = charMap[i];
          const text = span.dataset.originalText || span.textContent;

          if (index >= end) break; // Stop processing once past match

          if (index + text.length > start && index < end) {
            const highlightStart = Math.max(0, start - index);
            const highlightEnd = Math.min(text.length, end - index);

            highlighted =
              text.slice(0, highlightStart) +
              `<span style="background-color='red';" class="highlighted-text">${text.slice(
                highlightStart,
                highlightEnd
              )}</span>` +
              text.slice(highlightEnd);

            span.innerHTML = highlighted;
          }
        }
      }
    },

    handleResize() {
      //     const containerWidth = this.$refs.pdfViewer.clientWidth;

      // // Calculate scale based on screen size (adjust baseScale as needed)
      // const baseScale = 1; // Default scale
      // const baseWidth = 800; // Assume the original PDF width
      // this.scale = containerWidth / baseWidth * baseScale;

      this.renderPage(this.currentPage);
    },
    zoomIn() {
      this.scale += 0.1;
      this.renderPage(this.currentPage);
    },
    zoomOut() {
      this.scale = Math.max(0.5, this.scale - 0.1);
      this.renderPage(this.currentPage);
    },
  },
};
</script>

<style>
.pdf-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pdf-container {
  position: relative;
  display: flex;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.page-container {
  /* position: relative; */
  /* width: 100% !important; */
  /* height: 100% !important; */
}

/* .textLayer {
  position: absolute;
  pointer-events: none;
} */

.textLayer > span {
  display: block;
  margin-top: 3px;
  height: auto;
  left: 0;
  top: 0;
}

.textLayer {
  position: absolute;
  top: 0;
  left: 10%;
  transform-origin: 0 0; /* Aligns scaling perfectly */
  pointer-events: none;
  z-index: 2;
}

.highlighted-text {
  opacity: 1 !important;
  font-weight: bold;
  background-color: #000000;
  filter: brightness(120%) contrast(120%);
  mix-blend-mode: multiply;
  box-shadow: 0px 0px 5px 2px #0051ff;

  /* Small padding for better visibility */
}
</style>
